import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=2d0e94b3&scoped=true"
import script from "./editDialog.vue?vue&type=script&lang=ts"
export * from "./editDialog.vue?vue&type=script&lang=ts"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=2d0e94b3&prod&lang=scss"
import style1 from "./editDialog.vue?vue&type=style&index=1&id=2d0e94b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e94b3",
  null
  
)

export default component.exports